export enum KillSwitchKey {
  // 카카오 공유 버튼 보여줄지 말지
  SHOULD_SHOW_KAKAO_SHARE = 'zigzag:show-kakako-share',
}
